import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getOoraInfraDatasetList = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_OORA_INFRA_DATASET_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/oora-infra-dataset/list`, // check mount path
        formData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_OORA_INFRA_DATASET_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_OORA_INFRA_DATASET_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_OORA_INFRA_DATASET_LIST_FAILED", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const viewOoraInfraDataset = (id, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_OORA_INFRA_DATASET_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/oora-infra-dataset/view`, // check mount path
        { id },
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_OORA_INFRA_DATASET_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_OORA_INFRA_DATASET_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_OORA_INFRA_DATASET_FAIL", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const addOoraInfraDataset = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_OORA_INFRA_DATASET_REQUEST" });
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const { data } = await axios.post(
        `${BASE_URL}/oora-infra-dataset/add`, // check mount path
        formData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_OORA_INFRA_DATASET_SUCCESS", payload: data });
      } else {
        dispatch({ type: "ADD_OORA_INFRA_DATASET_FAILED", payload: data });
      }

      return data;
    } catch (error) {
      dispatch({ type: "ADD_OORA_INFRA_DATASET_FAILED", payload: error });
      return { statusCode: 500, message: error?.response?.data?.message || "Something went wrong" };
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const updateOoraInfraDataset = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_OORA_INFRA_DATASET_REQUEST" });
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const { data } = await axios.post(
        `${BASE_URL}/oora-infra-dataset/update`, // check mount path
        formData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_OORA_INFRA_DATASET_SUCCESS", payload: data });
      } else {
        dispatch({ type: "UPDATE_OORA_INFRA_DATASET_FAILED", payload: data });
      }

      return data;
    } catch (error) {
      dispatch({ type: "UPDATE_OORA_INFRA_DATASET_FAILED", payload: error });
      return { statusCode: 500, message: error?.response?.data?.message || "Something went wrong" };
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const removeOoraInfraDataset = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "REMOVE_OORA_INFRA_DATASET_REQUEST" });
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const { data } = await axios.post(
        `${BASE_URL}/oora-infra-dataset/remove`, // check mount path
        formData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_OORA_INFRA_DATASET_SUCCESS", payload: data });
      } else {
        dispatch({ type: "REMOVE_OORA_INFRA_DATASET_FAILED", payload: data });
      }

      return data;
    } catch (error) {
      dispatch({ type: "REMOVE_OORA_INFRA_DATASET_FAILED", payload: error });
      return { statusCode: 500, message: error?.response?.data?.message || "Something went wrong" };
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};